import util from 'util';

class QueueItem
{
  constructor() {
    // Id of this item. Not used by internally by SmartQ,
    // but the caller can use it to map the results
    this.itemId = 0;

    // Unique id of a singer
    this.singerId = 0;

    // Time when entered to waiting list, in seconds, from epoch for example
    this.timeEntered = 0;

    // Time when played in seconds, from epoch for example. 0 if not played
    this.timePlayed = 0;

    // These are set if item is manually controlled
    this.isManual = false;
    this.manualIndex = -1; // index in waiting list

    this.indexInEffectiveHistory = 0; // for sorting old items
    this.selectionReason = 'new'; // for logging only

    // For automatic pattern selector
    this.groupNum = 0;
    this.waitLimitApplied = false;
  }

  // for console.log  
  [util.inspect.custom](depth, opts) {
    return this.toString();
  }

  toString() {
    return JSON.stringify(this);
  }
  
  static compareTimeEntered(a, b) {
    // Ascending
    if (a.timeEntered != b.timeEntered) {
      return a.timeEntered < b.timeEntered ? -1 : 1;
    } else {
      return a.itemId < b.itemId ? -1 : 1;
    }
  }
  
  static compareEffectiveHistoryIndex(a, b) {
    if (a.indexInEffectiveHistory != b.indexInEffectiveHistory) {
      return a.indexInEffectiveHistory - b.indexInEffectiveHistory;
    } else {
      return QueueItem.compareTimeEntered(a, b);
    }
  }

  // Search by singer_id
  singerIndexInArray(itemList, startIndex = 0) {
    for (let i = startIndex; i < itemList.length; i++)
    {
      if (itemList[i].singerId == this.singerId)
        return i;
    }
    return -1;
  }

  // Search by singer_id, backwards
  lastSingerIndexInArray(itemList) {
    for (let i = itemList.length - 1; i >= 0; i--) {
      if (itemList[i].singerId == this.singerId)
        return i;
    }      
    return -1;
  }

  isSingerInArray(itemList) {
    return (this.singerIndexInArray(itemList) != -1);
  }
};

export default QueueItem
